export interface PhoneCountryOption {
  code: string;
  label: string;
  dialCode: string;
  nationalNumberLength: number;
}

// TODO: Should come from API
export const PHONE_COUNTRY_OPTIONS: PhoneCountryOption[] = [
  {
    code: 'RO',
    label: 'Romania (+40)',
    dialCode: '+40',
    nationalNumberLength: 9,
  },
  {
    code: 'GB',
    label: 'United Kingdom (+44)',
    dialCode: '+44',
    nationalNumberLength: 10,
  },
  {
    code: 'DE',
    label: 'Germany (+49)',
    dialCode: '+49',
    nationalNumberLength: 10,
  },
  {
    code: 'FR',
    label: 'France (+33)',
    dialCode: '+33',
    nationalNumberLength: 9,
  },
  {
    code: 'IT',
    label: 'Italy (+39)',
    dialCode: '+39',
    nationalNumberLength: 10,
  },
  {
    code: 'ES',
    label: 'Spain (+34)',
    dialCode: '+34',
    nationalNumberLength: 9,
  },
  {
    code: 'NL',
    label: 'Netherlands (+31)',
    dialCode: '+31',
    nationalNumberLength: 9,
  },
  {
    code: 'BE',
    label: 'Belgium (+32)',
    dialCode: '+32',
    nationalNumberLength: 9,
  },
  {
    code: 'AT',
    label: 'Austria (+43)',
    dialCode: '+43',
    nationalNumberLength: 10,
  },
  {
    code: 'PL',
    label: 'Poland (+48)',
    dialCode: '+48',
    nationalNumberLength: 9,
  },
  {
    code: 'BG',
    label: 'Bulgaria (+359)',
    dialCode: '+359',
    nationalNumberLength: 9,
  },
  {
    code: 'HU',
    label: 'Hungary (+36)',
    dialCode: '+36',
    nationalNumberLength: 9,
  },
  {
    code: 'CZ',
    label: 'Czechia (+420)',
    dialCode: '+420',
    nationalNumberLength: 9,
  },
  {
    code: 'GR',
    label: 'Greece (+30)',
    dialCode: '+30',
    nationalNumberLength: 10,
  },
  {
    code: 'PT',
    label: 'Portugal (+351)',
    dialCode: '+351',
    nationalNumberLength: 9,
  },
];

export const DEFAULT_PHONE_COUNTRY_DIAL_CODE = PHONE_COUNTRY_OPTIONS[0].dialCode;

export function getPhoneCountryOption(dialCode: string | null | undefined): PhoneCountryOption {
  return (
    PHONE_COUNTRY_OPTIONS.find((country) => country.dialCode === dialCode) ??
    PHONE_COUNTRY_OPTIONS[0]
  );
}

export function parsePhoneNumber(phone: string | null | undefined): {
  countryDialCode: string;
  nationalNumber: string;
} {
  const normalizedPhone = phone?.trim() ?? '';

  if (!normalizedPhone) {
    return {
      countryDialCode: DEFAULT_PHONE_COUNTRY_DIAL_CODE,
      nationalNumber: '',
    };
  }

  const digits = normalizedPhone.replace(/\D/g, '');

  const matchedCountry = PHONE_COUNTRY_OPTIONS.slice()
    .sort((left, right) => right.dialCode.length - left.dialCode.length)
    .find((country) => normalizedPhone.startsWith(country.dialCode));

  if (matchedCountry) {
    return {
      countryDialCode: matchedCountry.dialCode,
      nationalNumber: digits.replace(
        new RegExp(`^${matchedCountry.dialCode.replace('+', '')}`),
        '',
      ),
    };
  }

  if (digits.startsWith('0')) {
    return {
      countryDialCode: DEFAULT_PHONE_COUNTRY_DIAL_CODE,
      nationalNumber: digits.slice(1),
    };
  }

  return {
    countryDialCode: DEFAULT_PHONE_COUNTRY_DIAL_CODE,
    nationalNumber: digits,
  };
}

export function buildPhoneNumber(
  countryDialCode: string | null | undefined,
  nationalNumber: string | null | undefined,
): string {
  const normalizedNationalNumber = nationalNumber?.replace(/\D/g, '') ?? '';

  if (!normalizedNationalNumber) {
    return '';
  }

  return `${countryDialCode ?? DEFAULT_PHONE_COUNTRY_DIAL_CODE}${normalizedNationalNumber}`;
}
